import type { AssetVersionCommentDto } from '@api/Api';
import { combineUserName } from '@helpers/combineUserName';

/**
 * Who wrote a comment: its member or reviewer, or, for a comment imported
 * from Figma that no member wrote, its author there (their Figma name).
 * `colorKey` picks their avatar color, as an email does for users.
 */
export function commentAuthor(
  comment: Pick<AssetVersionCommentDto, 'user' | 'imported'>
) {
  const { user } = comment;
  if (user) {
    return {
      id: user.id,
      name: combineUserName(user),
      email: user.email,
      colorKey: user.email,
      pictureUrl: user.picture.url ?? null
    };
  }
  const imported = comment.imported?.author;
  if (imported) {
    return {
      id: imported.id,
      name: imported.name,
      email: '',
      colorKey: imported.id,
      pictureUrl: imported.picture.url ?? null
    };
  }
  return {
    id: '',
    name: combineUserName(null),
    email: '',
    colorKey: '',
    pictureUrl: null
  };
}
